module.exports = "<spk-card title=\"Admin Links\" divider=\"true\">\r\n  <ul class=\"nav navbar-nav item\">\r\n    <li>\r\n      <a [routerLink]=\"['/countries']\" routerLinkActive=\"active\">Countries</a>\r\n    </li>\r\n  </ul>\r\n</spk-card>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-type-links/admin-type-links.component.html
// module id = ./src/app/components/admin/admin-type-links/admin-type-links.component.html
// module chunks = main